import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useAppSelector } from './useAppSelector';

export const PROJECTS_QUERY_KEY = ['apis.v1.projects.list'];

export function useProjectsQuery() {
    const userId = useAppSelector((state) => state.auth.user?.id);

    return useQuery({
        queryKey: [...PROJECTS_QUERY_KEY, userId],
        queryFn: async () => (await Endpoints.v1.Projects.listProjects()).data ?? [],
        enabled: userId !== undefined,
        staleTime: 30_000,
        retry: 1,
    });
}
